var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "CompassTooltip",
        {
          attrs: { placement: "top", delay: { show: 0, hide: 1 } },
          scopedSlots: _vm._u([
            {
              key: "content",
              fn: function() {
                return [
                  _c("span", [_vm._v(_vm._s(_vm.$l10n.__("Saisie de temps")))]),
                  _vm._v(" "),
                  _c("span", { staticClass: "timetracking-shortcut" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.shortcut) +
                        "\n            "
                    )
                  ])
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _vm._v(" "),
          _c("CompassIconButton", {
            ref: "timetrackingRichTextTrigger",
            attrs: {
              icon: "performance",
              size: "small",
              active: _vm.localShowMenuTimetracking || _vm.isActive
            },
            on: { click: _vm.toggleTimetrackingForm }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "CompassPopover",
        {
          staticClass: "timetracking-popover",
          attrs: {
            title: _vm.$t.__(
              "richtext.customoptions.TimetrackingRichText.track_time"
            ),
            customClass: "custom-popover-timetracking",
            isVisible: _vm.localShowMenuTimetracking,
            triggerRef: "timetrackingRichTextTrigger",
            noCloseOnClickOutside: ".autocomplete-elselect"
          },
          on: { close: _vm.hideMenuTimetracking }
        },
        [
          _c(
            "div",
            { staticClass: "timetracking-form-container" },
            [
              _c(
                "CompassFormItem",
                {
                  staticClass: "timetracking-form-item-time",
                  attrs: {
                    label: _vm.$t.__(
                      "richtext.customoptions.TimetrackingRichText.time_passed"
                    ),
                    required: "",
                    requiredLabel: _vm.$t.__("common.labels.required")
                  }
                },
                [
                  _c("TimeInput", {
                    ref: "refTimeInput",
                    attrs: { mode: _vm.mode },
                    model: {
                      value: _vm.valueTime,
                      callback: function($$v) {
                        _vm.valueTime = $$v
                      },
                      expression: "valueTime"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "CompassFormItem",
                {
                  staticClass: "timetracking-form-item-service",
                  attrs: {
                    label: _vm.$t.__(
                      "richtext.customoptions.TimetrackingRichText.select_service"
                    ),
                    required: "",
                    requiredLabel: _vm.$t.__("common.labels.required")
                  }
                },
                [
                  _c("autocomplete-remote-input", {
                    attrs: {
                      mode: _vm.mode,
                      placeholder: _vm.$t.__(
                        "richtext.customoptions.TimetrackingRichText.select_service"
                      ),
                      limit: 1,
                      route: "/rest/catalogue/items/autocomplete",
                      "allowed-type": ["service"],
                      "query-parameters": { timetracking: true },
                      "default-options": _vm.defaultOptions,
                      "search-on-focus": true,
                      "popper-class": "autocomplete-elselect"
                    },
                    model: {
                      value: _vm.valueService,
                      callback: function($$v) {
                        _vm.valueService = $$v
                      },
                      expression: "valueService"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }